<!-- tornar-recorrente-form.component.html -->
<!--
  Formulário de fato de "Tornar compra de rotina" — periodicidade/início/
  término/pré-aviso + revisão (parametrizado) ou parametrização por item
  (cru). Extraído do antigo `TornarRecorrenteModalComponent` em T-271 para
  ser hospedado tanto pelo shell `MatDialog` (favoritos/tela de gestão)
  quanto pelo 4º `mat-step` de `adiciona-negociacao-composta` (origem
  bulk-list-import) — por isso não usa nenhuma diretiva `mat-dialog-*`.
  Visual conforme a spec de UX-1 (howl-san, docs/design/compra-de-rotina-ux-spec.md §3).
-->
<div class="tornar-recorrente-form">
  <p-toast></p-toast>

  <form [formGroup]="form" class="trm-form">
    <div class="trm-campo">
      <label for="trm-nome">{{ 'compra_rotina_campo_nome' | transloco }}</label>
      <input id="trm-nome" type="text" pInputText formControlName="nome" maxlength="80">
    </div>

    <div class="trm-linha">
      <div class="trm-campo">
        <label for="trm-periodicidade">{{ 'compra_rotina_periodicidade_label' | transloco }}</label>
        <p-select inputId="trm-periodicidade" formControlName="periodicidade" [options]="opcoesPeriodicidade"
          optionLabel="label" optionValue="valor" appendTo="body"></p-select>
      </div>
      <div class="trm-campo">
        <label for="trm-inicio">{{ 'compra_rotina_inicio_label' | transloco }}</label>
        <p-datepicker inputId="trm-inicio" formControlName="data_inicio" [minDate]="hoje" dateFormat="dd/mm/yy"
          [showIcon]="true" appendTo="body"></p-datepicker>
      </div>
    </div>

    <fieldset class="trm-campo" formGroupName="termino">
      <legend>{{ 'compra_rotina_termino_label' | transloco }}</legend>
      <div class="trm-radios">
        <div class="trm-radio-opcao">
          <p-radiobutton name="tipo" value="nunca" formControlName="tipo" inputId="termino-nunca"></p-radiobutton>
          <label for="termino-nunca">{{ 'compra_rotina_termino_nunca' | transloco }}</label>
        </div>

        <div class="trm-radio-opcao">
          <p-radiobutton name="tipo" value="em_data" formControlName="tipo" inputId="termino-data"></p-radiobutton>
          <label for="termino-data">{{ 'compra_rotina_termino_em_data' | transloco }}</label>
        </div>
        <p-datepicker *ngIf="terminoTipo === 'em_data'" class="trm-termino-detalhe" formControlName="data"
          [minDate]="form.get('data_inicio')?.value" dateFormat="dd/mm/yy" [showIcon]="true" appendTo="body"
          [attr.aria-label]="'compra_rotina_termino_em_data' | transloco"></p-datepicker>

        <div class="trm-radio-opcao">
          <p-radiobutton name="tipo" value="apos_n" formControlName="tipo" inputId="termino-apos-n"></p-radiobutton>
          <label for="termino-apos-n">{{ 'compra_rotina_termino_apos_n' | transloco }}</label>
        </div>
        <p-inputnumber *ngIf="terminoTipo === 'apos_n'" class="trm-termino-detalhe" formControlName="ocorrencias"
          [min]="1" [max]="ocorrenciasMax" [showButtons]="true"
          suffix=" {{ 'compra_rotina_termino_apos_n_sufixo' | transloco }}"
          [attr.aria-label]="'compra_rotina_termino_apos_n' | transloco"></p-inputnumber>
      </div>
    </fieldset>

    <div class="trm-campo trm-campo--curto">
      <label for="trm-pre-aviso">{{ 'compra_rotina_pre_aviso_label' | transloco }}</label>
      <p-inputnumber inputId="trm-pre-aviso" formControlName="pre_aviso_dias" [min]="0" [max]="15"
        suffix=" {{ 'dias' | transloco }}"></p-inputnumber>
      <small class="trm-campo-ajuda">{{ 'compra_rotina_pre_aviso_ajuda' | transloco }}</small>
    </div>

    <hr class="trm-divisor">

    <h3 class="trm-itens-titulo">{{ 'compra_rotina_itens_titulo' | transloco }} ({{ modo === 'parametrizado' ? itensParametrizados.length : itensFormArray.controls.length }})</h3>

    <!-- MODO PARAMETRIZADO — itens já congelados vindos do stepper, só review.
         Payload congelado não carrega imagemUrl (T-274): a miniatura vira um
         placeholder monoline consistente com o modo cru, em vez de ficar sem
         nenhum elemento visual à esquerda do nome. -->
    <ul class="trm-itens trm-itens--review" *ngIf="modo === 'parametrizado'">
      <li class="trm-item" *ngFor="let item of itensParametrizados">
        <span class="trm-item-thumb trm-item-thumb--vazio" aria-hidden="true">
          <i class="pi pi-image"></i>
        </span>
        <div class="trm-item-info">
          <p class="trm-item-nome">{{ item.nome }}</p>
          <p class="trm-item-resumo">
            {{ item.quantidade }} &times; {{ (item.novo ? 'novo' : 'usado') | transloco }}
            &middot; {{ item.duracao }} {{ 'dias' | transloco }}
            <span *ngIf="item.valor_pretendido">
              &middot; {{ 'valor_pretendido_unidade' | transloco }}: {{ item.valor_pretendido | currency:'BRL' }}
            </span>
          </p>
        </div>
      </li>
    </ul>

    <!-- MODO CRU — itens vindos de favoritos, expõe os campos por item.
         Cabeçalho reorganizado (T-274): miniatura com moldura, nome, e um
         resumo compacto dos valores atuais do item empurrado para a direita
         — preenche o vazio que sobrava no card e dá uma prévia sem precisar
         expandir. -->
    <p-accordion *ngIf="modo === 'cru'" [multiple]="false" styleClass="trm-itens--cru" formArrayName="itens">
      <p-accordion-tab *ngFor="let item of itensFormArray.controls; let i = index" [formGroupName]="i">
        <ng-template pTemplate="header">
          <div class="trm-item-cabecalho">
            <span class="trm-item-thumb" [class.trm-item-thumb--vazio]="!item.value.imagemUrl">
              <img *ngIf="item.value.imagemUrl" [src]="item.value.imagemUrl" [alt]="item.value.nome">
              <i *ngIf="!item.value.imagemUrl" class="pi pi-image" aria-hidden="true"></i>
            </span>
            <div class="trm-item-textos">
              <span class="trm-item-nome">{{ item.value.nome }}</span>
              <span class="trm-item-resumo-inline">
                {{ item.value.quantidade }} &times; {{ (item.value.condicao === 'usado' ? 'usado' : 'novo') | transloco }}
                &middot; {{ item.value.duracao }} {{ 'dias' | transloco }}
                <ng-container *ngIf="item.value.valor_pretendido">
                  &middot; {{ 'valor_pretendido_unidade' | transloco }} {{ item.value.valor_pretendido | currency:'BRL' }}
                </ng-container>
              </span>
            </div>
          </div>
        </ng-template>

        <div class="trm-linha">
          <div class="trm-campo">
            <label [attr.for]="'quantidade-' + i">{{ 'quantidade_simples' | transloco }}</label>
            <p-inputnumber [inputId]="'quantidade-' + i" formControlName="quantidade" [min]="1" [max]="100"></p-inputnumber>
          </div>
          <div class="trm-campo">
            <label>{{ 'condicao_produto' | transloco }}</label>
            <p-selectbutton formControlName="condicao" [options]="opcoesCondicao" optionLabel="label" optionValue="valor"></p-selectbutton>
          </div>
        </div>
        <div class="trm-linha">
          <div class="trm-campo">
            <label [attr.for]="'duracao-' + i">{{ 'duracao_negociacao' | transloco }}</label>
            <p-select [inputId]="'duracao-' + i" formControlName="duracao" [options]="duracoes" optionLabel="label" optionValue="codigo" appendTo="body"></p-select>
          </div>
          <div class="trm-campo">
            <label [attr.for]="'valor-' + i">{{ 'valor_pretendido_unidade' | transloco }}</label>
            <p-inputnumber [inputId]="'valor-' + i" formControlName="valor_pretendido" mode="currency" currency="BRL" locale="pt-BR" [min]="0" [max]="999999.99"></p-inputnumber>
          </div>
        </div>
        <div class="trm-campo trm-campo--checkbox">
          <p-checkbox formControlName="encerrar_automaticamente" [binary]="true" [inputId]="'encerrar-' + i"></p-checkbox>
          <label [attr.for]="'encerrar-' + i">{{ 'finalizar_lance_igual' | transloco }}</label>
        </div>
      </p-accordion-tab>
    </p-accordion>

    <p class="trm-erro" *ngIf="erro" role="alert">{{ erro }}</p>
  </form>

  <div class="trm-footer">
    <p-button [label]="'compra_rotina_modal_botao_cancelar' | transloco" severity="secondary" [text]="true"
      (onClick)="cancelar()" [disabled]="salvando"></p-button>
    <p-button [label]="'compra_rotina_modal_botao_salvar' | transloco" (onClick)="salvar()" [loading]="salvando"
      [disabled]="!formValido"></p-button>
  </div>
</div>
